export function extractNamespaceFromScriptSrc(scriptSrc: string): string | null {
  const regex = /[/\\](stemble-[-\w]+?)(?:\.min)?\.js$/;
  const matches = scriptSrc.match(regex);

  return matches?.[1] ?? null;
}
